// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Cycle Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: string, sortOrder: 'ASC' | 'DESC',  isLocked: boolean, userId: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Cycle.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Cycle Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: string, sortOrder: 'ASC' | 'DESC', isLocked: boolean, userId: number }}} option
 *
 * @returns
 */
export const GetCycleList = async (option) => {
  const response = await $api.get(Endpoints.Cycle.GetCycleList(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Cycle Create
/**
 *
 * @param {{"projectId": 0,"serialNumber": "string","calculationDate": "2025-01-21T07:06:11.481Z","condansationTemp": 0,"evaporationTemp": 0,"refrigerantId": 0,"condenserAirInletTemp": 0,"condenserAirInletHumidity": 0,"condenserBatteryId": 0,"evaporatorBatteryId": 0,"condenserFanFlow": 0,"coolingCapacity": 0,"evaporatorAirInletTemp": 0,"evaporatorAirInletHumidity": 0,"evaporatorFanFlow": 0,"hp": 0,"lp": 0,"massFlow": 0,"rejectedHeat": 0,"subcooling": 0,"superheat": 0,"work": 0,"calculateRequest": {"refrigerantId": 0,"superheat": 0,"subcooling": 0,"condensingTemp": 0,"condenserFanFlow": 0,"condenserAirInletTemp": 0,"condenserAirInletHumidity": 0,"evaporatorAirInletTemp": 0,"evaporatorAirInletHumidity": 0,"evaporatorFanFlow": 0,"evapBatteryId": 0,"condBatteryId": 0,"evapQuantity": 0,"condQuantity": 0,"compressorBrandId": 0,"compressorRefrigerantId": 0,"compRefrigetantModelId": 0,"compressorQuantity": 0,"constantAirFlowRate": true,"variableAirFlowRate": true}}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Cycle.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Cycle Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Cycle.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Cycle Update
/**
 *
 * @param {{"projectId": 0,"serialNumber": "string","calculationDate": "2025-01-21T07:06:11.481Z","condansationTemp": 0,"evaporationTemp": 0,"refrigerantId": 0,"condenserAirInletTemp": 0,"condenserAirInletHumidity": 0,"condenserBatteryId": 0,"evaporatorBatteryId": 0,"condenserFanFlow": 0,"coolingCapacity": 0,"evaporatorAirInletTemp": 0,"evaporatorAirInletHumidity": 0,"evaporatorFanFlow": 0,"hp": 0,"lp": 0,"massFlow": 0,"rejectedHeat": 0,"subcooling": 0,"superheat": 0,"work": 0,"calculateRequest": {"refrigerantId": 0,"superheat": 0,"subcooling": 0,"condensingTemp": 0,"condenserFanFlow": 0,"condenserAirInletTemp": 0,"condenserAirInletHumidity": 0,"evaporatorAirInletTemp": 0,"evaporatorAirInletHumidity": 0,"evaporatorFanFlow": 0,"evapBatteryId": 0,"condBatteryId": 0,"evapQuantity": 0,"condQuantity": 0,"compressorBrandId": 0,"compressorRefrigerantId": 0,"compRefrigetantModelId": 0,"compressorQuantity": 0,"constantAirFlowRate": true,"variableAirFlowRate": true}}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Cycle.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Cycle Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Cycle.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Cycle Create
/**
 *
 * @param {{refrigerantId: number, superheat: number, subcooling: number, condensingTemp: number, condenserFanFlow: number, condenserAirInletTemp: number, condenserAirInletHumidity: number, evaporatorAirInletTemp: number, evaporatorAirInletHumidity: number, evaporatorFanFlow: number, evapBatteryId: number, condBatteryId: number, evapQuantity: number, condQuantity: number, compressorBrandId: number, compressorRefrigerantId: number, compRefrigetantModelId: number, compressorQuantity: number, constantAirFlowRate: boolean, variableAirFlowRate: boolean,}} form
 *
 * @returns
 */
export const CalculateCycle = async (form) => {
  const response = await $api.post(Endpoints.Cycle.CalculateCycle(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Cycle UpdateLockStatus
/**
 *
 * @param {{ params: { id: string }, query: object}} option
 * @param {{isLocked: boolean}} form
 *
 * @returns
 */
export const UpdateLockStatus = async (option, form) => {
  const response = await $api.put(
    Endpoints.Cycle.UpdateLockStatus(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Cycle GetCycleLogs
/**
 *
 * @param {{ query: { id: string, limit: number, page: number }, params: object}} option
 *
 * @returns
 */
export const GetCycleLogs = async (option) => {
  const response = await $api.get(Endpoints.Cycle.GetCycleLogs(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Cycle ReactivateCycle
/**
 *
 * @param {{ id: number }} form
 *
 * @returns
 */
export const ReactivateCycle = async (form) => {
  const response = await $api.post(Endpoints.Cycle.ReactivateCycle(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Cycle ReactivateCycle
/**
 *
 * @param {{ id: number }} form
 *
 * @returns
 */
export const CalculateMultipleCycle = async (form) => {
  const response = await $api.post(
    Endpoints.Cycle.CalculateMultipleCycle(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Cycle ReactivateCycle
/**
 *
 * @param {{ id: number }} form
 *
 * @returns
 */
export const CalculateCycleSelection = async (form) => {
  const response = await $api.post(
    Endpoints.Cycle.CalculateCycleSelection(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  GetCycleList,
  Create,
  GetById,
  Update,
  Delete,
  CalculateCycle,
  UpdateLockStatus,
  GetCycleLogs,
  ReactivateCycle,
  CalculateMultipleCycle,
  CalculateCycleSelection,
};
